import React from "react";
import ReactBodymovin from "react-bodymovin";
import animation from "../animation/button7.json";
const Done = (props) => {
    const bodymovinOptions = {
        loop: true,
        autoplay: true,
        prerender: true,
        animationData: animation,
    };

    return (
        <div className="">
            <div className="mx-auto w-1/2 pb-4">
                <ReactBodymovin options={bodymovinOptions} />
            </div>
            <div className="flex justify-center items-center flex-col mb-5">
                <span className="text-sm w-3/4 text-shippify-darkGray leading-tight text-center pt-6">
                    Your account is still not activated. Activate your account by checking your email
                </span>
            </div>
        </div>
    );
};
export default Done;
